import React, { useRef } from 'react'
import { Editor } from "@tinymce/tinymce-react";

import { Button, } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {

    selectPriseEnChargeGrid,

} from "../../features/PriseEnCharge/PriseEnChargeSlice";

function PapierBloc() {
    const PriseEnChargeState = useSelector(selectPriseEnChargeGrid);
    const {

        priseEnChargeDataAllRowsBloc,
        priseEnChargeClinique
    } = PriseEnChargeState;


    const editorRef = useRef(null);

    let titre = '<h3 style="text-align: center; line-height: 1;">Programme bloc opératoire</h3>'
    let docteur = `<h3 style="text-align: center; line-height: 1;">${priseEnChargeDataAllRowsBloc[0]?.user_name.toUpperCase()} --- Clinique : ${priseEnChargeClinique === "all" ? "Situation Globale" : priseEnChargeDataAllRowsBloc[0]?.NomClinique.toUpperCase()}</h3>`
    let date = `<h3 style="text-align: center; line-height: 1;"><span style="text-decoration: underline;">Le : ${priseEnChargeDataAllRowsBloc[0]?.date_Lisible}</span></h3>`

    let subElement = priseEnChargeDataAllRowsBloc.map((item, index) =>
        `<tr >
            <td style="text-align: center;">   ${index + 1}    </td>
            <td style=" text-align: center;">   ${item.nom}    </td>
            <td style=" text-align: center;">   ${item.prenom}     </td>
            <td style=" text-align: center;">   ${item.Nom_Type_D_Operationcol}     </td>
            <td style=" text-align: center;">   ${item.commentaire}     </td>
            <td style=" text-align: center;">   ${item.mutualiste ? 'Avec' : 'Sans'}    </td>
            <td style=" text-align: center;">   ${item.NomClinique}    </td>
        </tr>`
    )



    let tableau =
        `<table style="border-collapse: collapse; width: 100%; margin-left: auto; margin-right: auto;" border="1">
    <tbody>
    <tr>
    <th style=" text-align: center;">Numéro</th>
    <th style=" text-align: center;">Nom</th>
    <th style=" text-align: center;">Prénom</th>
    <th style=" text-align: center;">Type Geste</th>
    <th style=" text-align: center;">Observations</th>
    <th style=" text-align: center;">Mutuelle</th>
    <th style=" text-align: center;">Clinique</th>
    </tr>
    ${subElement}
    
    </tbody>
    </table>`

    let dataToSeeFinal = titre + docteur + date + tableau

    let Contents = (
        <div className='someSpace'>
            <Editor
                // apiKey="4wmks1hxrd175lnu674946w8nb95pzv263exeq2v73z02al0"
                tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
                onInit={(evt, editor) => (editorRef.current = editor)}
                initialValue={dataToSeeFinal}
                init={{
                    // selector: "textarea",
                    branding: false,
                    height: "81.5vh",
                    menubar: true,
                    plugins: [
                        "advlist autolink lists link image charmap print preview anchor",
                        "searchreplace visualblocks code fullscreen",
                        "insertdatetime media table paste code help ",
                        "print",
                    ],
                    toolbar:
                        "undo redo | formatselect | " +
                        "bold italic underline print forecolor backcolor | alignleft aligncenter " +
                        "alignright alignjustify | bullist numlist outdent indent | ",
                    content_style:
                        "body { font-family:Helvetica,Arial,sans-serif; font-size:16px }",
                }}
            />
        </div>
    );



    return (
        <div>
            {Contents}
            <hr />
            <Link to="/bloc_Main">
                <Button floated="right" color="blue">retour</Button>
            </Link>

        </div>
    )
}

export default PapierBloc